import attemptToSubmitAddEntityFeedback from './attemptToSubmitAddEntityFeedback';
import createEntityFeedbackEntry from './createEntityFeedbackEntry';
import EntityAddSource from 'owa-service/lib/contract/EntityAddSource';
import EntityFeedbackEntry from 'owa-service/lib/contract/EntityFeedbackEntry';
import { action } from 'satcheljs/lib/legacy';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';
import { format } from 'owa-strings';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { trace } from 'owa-trace';

/**
 * Logs Add entity feedback for location
 * @param feedbackManagerState: the feeback manager
 * @param entityAddSource: the entity add source
 * @param queryString: the query string associated with the add entity
 * @param displayName: the display name
 * @param transactionId: the transaction id
 * @param recipientEmailAddresAndPositionIndexesDictionary: A dictionary of email addresses and their indexes
 * @param extraData: Optional parameter that contains key/value pairs of additional non-standard data that is to be included when sending an AddEntity event
 */
export default action('addEntity')(function addEntity(
    feedbackManagerState: FeedbackManagerState,
    entityAddSource: EntityAddSource,
    queryString: string,
    displayName: string,
    transactionId: string,
    recipientEmailAddressesAndPositionIndexesDictionary: Dictionary<any>,
    extraData?: Dictionary<any>
) {
    if (!recipientEmailAddressesAndPositionIndexesDictionary) {
        trace.warn(
            format(
                '{0} - Attempting to add entity without recipientEmailAddressesAndPositionIndexesDictionary',
                feedbackManagerState.entityScenarioName
            )
        );
        return null;
    }

    if (feedbackManagerState && feedbackManagerState.hasSessionStarted) {
        let jsonPropertyBagDictionary = {
            QueryString: queryString ? queryString : '',
            QueryStringLength: isNullOrWhiteSpace(queryString) ? 0 : queryString.length,
            DisplayName: displayName,
            EmailAddressAndPositionIndex: recipientEmailAddressesAndPositionIndexesDictionary,
        };

        if (extraData) {
            Object.keys(extraData).forEach(key => {
                jsonPropertyBagDictionary[key] = extraData[key];
            });
        }

        let jsonPropertyBag = JSON.stringify(jsonPropertyBagDictionary);
        let targetList = JSON.stringify(
            Object.keys(recipientEmailAddressesAndPositionIndexesDictionary)
        );

        let entry: EntityFeedbackEntry = createEntityFeedbackEntry(
            feedbackManagerState,
            transactionId,
            'EntityAdded',
            targetList,
            entityAddSource,
            jsonPropertyBag
        );

        attemptToSubmitAddEntityFeedback(feedbackManagerState, entry, false);

        trace.info(
            format(
                '{0} Added Entity {1}. Session id: {2}',
                feedbackManagerState.entityScenarioName,
                targetList,
                feedbackManagerState.clientSessionId
            )
        );
    }
});
